import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledHeaderContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '$9',
  marginTop: '$6',
});

export const StyledSelectorsContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
});
